import React, { Component } from 'react';

import Header from '../Header/header';
import Footer from '../Footer/footer';
import getCompanies from '../../services/getCompanyList';
import './displayCompanyList.scss';
import { Navigate } from 'react-router-dom';
import toastNotify from '../../utils/toastNotifier';
import withRouter from '../withRouter';
import { auth as AuthObject } from '../../services/login';
import cookie from '../../cookieHelper/cookie';
;



class DisplayCompanyList extends React.Component {
    constructor() {
        super();
        this.state = {
            name: '',
            logo: '',
            id: '',
            redirect: false,
            redirectToEditCompany: false,
            companyId : '',
            tokencheck : true
        }
        this.companyList();
    }

    redirectHandler = () => {
        console.log("in redirectHandler");
        this.setState({
            redirect: true
        })
    }

    redirectToEditCompanyHandler = (companyID) =>{
        this.setState({
            redirectToEditCompany : true,
            companyId : companyID
        })
    }

    companyList = async () => {
        let list = {};
        let companiesResult = await getCompanies();

        if (!(companiesResult instanceof Error)) {
            if (companiesResult.status.code == "10200"){
                list = companiesResult.data[0];

                if(typeof list === 'undefined'){
                    return toastNotify(3 , "No companies found.")
                }
                else if(Object.keys(list).length === 0 ){
                    return toastNotify(3 , "No companies found.")
                }
                let rows = list.companies.map((item) => {
                    return {
                        name: item.companyName,
                        logo: item.companyLogo,
                        id: item.id
                    }
                })
                // console.log("Name:", this.state.name);
                this.setState({
                    rawCompanies: list.companies,
                    rows: rows
                })
            }else{
                toastNotify("3", "Some error occured while fetching companies list")
            }
        }else{
            const response = JSON.parse(companiesResult.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }
            else{
                toastNotify("3", "Some error occured while fetching companies list")

            }
    }
    }

    componentDidMount = () => {
        var elem = document.getElementById("ac");
        elem.classList.add("active");
    }

    render() {

        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }
        
        if (this.state.redirect) {
            return <Navigate to={'/addCompany'} />
        }
        if(this.state.redirectToEditCompany){
            return <Navigate to={`/editCompany/${this.state.companyId}`} />
        }
        let rows;
        if (this.state.rawCompanies) {
            rows = (
                this.state.rawCompanies.map((item, index) => {

                    return (
                        // <tr storytype={props.fileType} >

                        <tr key={index}>
                            <td>
                                <div className="checkboxes">
                                    <p>{item.companyName}</p>

                                </div>
                            </td>
                            <td>

                                <div >
                                    <img src={item.companyLogo} />
                                </div>

                            </td>

                            <td>
                                <div className="checkboxes">
                                    <p>{item.id}</p>

                                </div>
                            </td>
                            <td>
                                <div className="checkboxes">
                                    <p>{item.companyCode}</p>

                                </div>
                            </td>
                            <td>
                                <p>{item.isPremium ? 'Premium' : 'Non Premium'}</p>
                            </td>
                            <td>
                                <button className="color_green btn-default" onClick={()=>this.redirectToEditCompanyHandler(item.id)}>Edit</button>
                            </td>
                        </tr>
                    )
                })
            )
        }


        return (
            <div className="bodyWrapper" onClick={this.eventHandleClick}>
                <Header />
                <section className="listing_header">

                    <div className="wrapper">
                        <div className="wrapperButton" onClick={this.redirectHandler}>Add New Company</div>
    
                        <h1>Display Company List</h1>

                        
                        <div className="wrapperTable">
                            <table border="1" className="mtb20 recruiter_listing" width="100%">
                                <tbody>
                                    <tr className="table-header">
                                        <th className="table_header">Name</th>
                                        <th className="table_header">Logo</th>
                                        {/* <th className="table_header">Expiry</th> */}
                                        <th className="table_header">ID</th>
                                        <th className="table_header">Centralised Company ID</th>
                                        <th className="table_header">Company Status</th>
                                        <th className="table_header ">Actions</th>
                                    </tr>
                                    {rows}
                                </tbody>
                            </table>

                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default withRouter(DisplayCompanyList);    